import * as React from 'react';
export const Label = ({ title, forHtml, required }) => (React.createElement("label", { className: `control-label ${required ? 'required-field' : ''}`, htmlFor: forHtml },
    title,
    required && ' ',
    required && React.createElement("span", { className: "red-star" }, "*")));
